<template>
    <section
        ref="section3"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="3"></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <figure class="flex grow flex-col gap-11 lg:w-full">
                <figure class="ml-auto mr-auto flex w-full max-w-xl gap-3">
                    <div><v-icon icon="map-pin" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 text-heading-3-desktop">
                            Vnesite naslov vaše nepremičnine
                        </div>
                        <div class="text-body-regular text-black-40">
                            Naslov vaše nepremičnine ne bo javno objavljen na
                            oglasu.
                        </div>
                    </div>
                </figure>
                <form
                    method="POST"
                    :action="routes.submitForm"
                    id="select-address-step"
                >
                    <v-csrf-token></v-csrf-token>
                    <figure
                        class="ml-auto mr-auto flex w-full max-w-lg grow flex-col"
                    >
                        <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-6">
                            <li class="col-span-2">
                                <v-form-input
                                    id="propertyAddress"
                                    label="Naslov"
                                    type="text"
                                    :value="propertyAddress"
                                    v-model="propertyAddress"
                                    name="strasse"
                                ></v-form-input>
                            </li>
                            <li class="col-span-2">
                                <v-form-input
                                    id="propertyNumber"
                                    label="Hišna številka"
                                    type="text"
                                    :value="propertyNumber"
                                    v-model="propertyNumber"
                                    name="hausnummer"
                                ></v-form-input>
                            </li>
                            <li class="col-span-4">
                                <div class="relative flex items-center">
                                    <label
                                        for="location"
                                        class="absolute left-0 top-0 z-10 flex h-full w-full cursor-pointer items-center rounded-full bg-white px-6 font-medium text-black-50 ring-1 ring-inset ring-gray"
                                        v-if="
                                            !hideCountryLabel &&
                                            (countryOption == null ||
                                                countryOption.value == '')
                                        "
                                        @click="openCountry"
                                    >
                                        <div
                                            class="overflow-hidden text-ellipsis whitespace-nowrap"
                                        >
                                            <span
                                                class="text-[14px] font-medium text-black-40"
                                            >
                                                Država
                                            </span>
                                        </div>
                                    </label>
                                    <v-select
                                        class="v-select--xs w-full rounded-full bg-white font-medium ring-1 ring-inset ring-gray"
                                        :options="parseCountries()"
                                        placeholder=""
                                        v-model="countryOption"
                                        label="custom_label"
                                        @search:focus="onFocusCountry"
                                        @search:blur="onBlurCountry"
                                        ref="location"
                                        id="location"
                                        :name="'location'"
                                        @option:selecting="populateFieldsCountry"
                                    >
                                        <template v-slot:no-options>
                                            Za ta iskalni niz ni zadetkov.
                                        </template>
                                    </v-select>
                                    <input
                                        type="hidden"
                                        name="land"
                                        :value="
                                            countryOption == null
                                                ? ''
                                                : countryOption.value
                                        "
                                    />
                                </div>
                            </li>
                            <li class="col-span-4">
                                <div class="relative flex items-center">
                                    <label
                                        for="location"
                                        class="absolute left-0 top-0 z-10 flex h-full w-full cursor-pointer items-center rounded-full bg-white px-6 font-medium text-black-50 ring-1 ring-inset ring-gray"
                                        v-if="
                                            !hideLocationLabel &&
                                            (locationOption == null ||
                                                locationOption.value == '')
                                        "
                                        @click="openLocation"
                                    >
                                        <div
                                            class="overflow-hidden text-ellipsis whitespace-nowrap"
                                        >
                                            <span
                                                class="text-[14px] font-medium text-black-40"
                                            >
                                                Kraj
                                            </span>
                                        </div>
                                    </label>
                                    <v-select
                                        class="v-select--xs w-full rounded-full bg-white font-medium ring-1 ring-inset ring-gray"
                                        :options="parseLocations"
                                        placeholder=""
                                        v-model="locationOption"
                                        label="custom_label"
                                        @search:focus="onFocus"
                                        @search:blur="onBlur"
                                        ref="location"
                                        id="location"
                                        :name="'location'"
                                        @option:selecting="populateFields"
                                    >
                                        <template v-slot:no-options>
                                            Za ta iskalni niz ni zadetkov.
                                        </template>
                                    </v-select>
                                    <input
                                        type="hidden"
                                        name="regionaler_zusatz"
                                        :value="
                                            locationOption == null
                                                ? ''
                                                : locationOption.value
                                        "
                                    />
                                </div>
                            </li>
                            <li class="col-span-4">
                                <v-form-input
                                    id="propertyPostalNumber"
                                    label="Poštna številka"
                                    type="text"
                                    :value="propertyPostalNumber"
                                    v-model="propertyPostalNumber"
                                    name="plz"
                                ></v-form-input>
                            </li>
                            <li class="col-span-4">
                                <v-checkbox
                                    :id="'show_location'"
                                    class="text-small-text-medium text-black-78"
                                    :label="'Ali želite, da je lokacija nepremičnine na oglasu vidna?'"
                                    checkbox-position="right"
                                    :name="'show_location'"
                                    :value="1"
                                    @vchanged="showLocation = !showLocation"
                                    :checked="Boolean(showLocationComputed)"
                                ></v-checkbox>
                                <input
                                    type="hidden"
                                    :value="showLocationComputed"
                                    name="objektadresse_freigeben"
                                />
                            </li>
                            <v-form-input
                                class="hidden"
                                id="propertyPlace"
                                label="Kraj"
                                type="text"
                                :value="propertyPlace"
                                v-model="propertyPlace"
                                name="ort"
                            ></v-form-input>
                        </ul>
                    </figure>
                </form>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('select-address-step')"
                :class="[
                    'button button--md h-[48px] w-[240px] px-6',
                    validated ? '' : 'button button--gray',
                ]"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },
    props: {
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
        old: {
            type: Object,
            required: false,
            default: {},
        },
    },
    data() {
        return {
            locationOption: null,
            countryOption: null,
            hideLocationLabel: false,
            hideCountryLabel: false,
            propertyAddress: null,
            propertyNumber: null,
            propertyPostalNumber: null,
            propertyPlace: null,
            showLocation: false,
            showCountry: false,
        };
    },
    mounted() {
        this.locationOption = {
            value: this.stepData.regionaler_zusatz,
            custom_label: this.stepData.regionaler_zusatz_label,
        };
        this.countryOption = {
            value: this.old.land ? this.old.land : (this.stepData.land ?? 'SVN'),
            custom_label: this.countryToLabel(this.old.land ? this.old.land : (this.stepData.land ?? 'SVN')),
        };
        this.propertyAddress = this.old.strasse
            ? this.old.strasse
            : this.stepData.strasse;
        this.propertyNumber = this.old.hausnummer
            ? this.old.hausnummer
            : this.stepData.hausnummer;
        this.propertyPostalNumber = this.old.plz
            ? this.old.plz
            : this.stepData.plz;
        this.propertyPlace = this.old.ort ? this.old.ort : this.stepData.ort;

        this.showLocation = this.old.objektadresse_freigeben
            ? this.old.objektadresse_freigeben
            : this.stepData.objektadresse_freigeben;
    },
    methods: {
        countryToLabel(value) {
            if (value === 'SVN') {
                return 'Slovenija';
            }

            if (value === 'HRV') {
                return 'Hrvaška';
            }

            return null;
        },
        populateFields(selectedLocation) {
            this.propertyPlace = selectedLocation.custom_label;
            this.propertyPostalNumber = selectedLocation.postal_code;
        },
        populateFieldsCountry(selectedCountry) {
            this.propertyPlace = null;
            this.propertyPostalNumber = null;
            this.locationOption = null;
        },
        submitForm(formId) {
            if (this.validated) document.getElementById(formId).submit();
        },
        openLocation() {
            // Access the Vue Select instance using the ref
            const selectComponent = this.$refs.location;

            // Check if the Vue Select instance exists and is defined
            if (selectComponent) {
                selectComponent.$refs.search.focus();
            }
        },
        openCountry() {
            // Access the Vue Select instance using the ref
            const selectComponent = this.$refs.country;

            // Check if the Vue Select instance exists and is defined
            if (selectComponent) {
                selectComponent.$refs.search.focus();
            }
        },
        parseCountries() {
            return [
                {value: 'SVN', custom_label: this.countryToLabel('SVN')},
                {value: 'HRV', custom_label: this.countryToLabel('HRV')},
            ]
        },
        onFocus() {
            this.hideLocationLabel = true;
        },
        onBlur() {
            this.hideLocationLabel = false;
        },
        onFocusCountry() {
            this.hideLocationLabel = true;
        },
        onBlurCountry() {
            this.hideLocationLabel = false;
        },
    },
    computed: {
        parseLocations() {
            let parsedLocations = [];

            Object.values(this.stepData.locations).filter((item) => item.country === this.countryOption?.value ?? 'SVN').forEach((object) => {
                parsedLocations.push({
                    value: object.code,
                    custom_label: object.location,
                    postal_code: object.postal_code,
                });
            });

            return parsedLocations;
        },
        showLocationComputed() {
            return this.showLocation ? 1 : 0;
        },
        showCountryComputed() {
            return this.showLocation ? 1 : 0;
        },
        validated() {
            if (
                !this.locationOption ||
                !this.locationOption.value ||
                !this.propertyAddress ||
                !this.propertyNumber ||
                !this.propertyPostalNumber ||
                !this.propertyPlace
            )
                return false;

            return true;
        },
    },
};
</script>
